import { useEffect, useRef } from "react"
import { useAppDispatch, useAppSelector } from "hooks/redux"
import { useDashboardId } from "../context/dashboard-id"
import { tradeSlice } from "../store/trade-slice"
import { DEFAULT_CORE_STATE } from "../store/core-slice"

// Renders nothing — side-effects only.
export default function TradeSyncEffect() {
  const dashboardId = useDashboardId()
  const dispatch = useAppDispatch()

  const instrument = useAppSelector((s) => s.dashboard.core[dashboardId]?.instrument ?? DEFAULT_CORE_STATE.instrument)
  const modelId = useAppSelector((s) => s.dashboard.model[dashboardId]?.modelId ?? null)

  const prevInstrumentIdRef = useRef(instrument?.id)
  const prevModelIdRef = useRef(modelId)

  useEffect(() => {
    const instrumentChanged = instrument?.id !== prevInstrumentIdRef.current
    const modelChanged = modelId !== prevModelIdRef.current

    if (instrumentChanged || modelChanged) {
      dispatch(tradeSlice.actions.resetTradeContext({ dashboardId }))
    }

    prevInstrumentIdRef.current = instrument?.id
    prevModelIdRef.current = modelId
  }, [instrument?.id, modelId, dispatch, dashboardId])

  return null
}
